export const vcsAccountIcons: any = {
  GITHUB: 'github-account',
  GITLAB: 'gitlab-account',
  BITBUCKET: 'bitbucket-account',
};

export const cloudAccountIcons: any = {
  AWS: 'aws',
  AZURE: 'azure',
  GCP: 'gcp',
  KUBERNETES: 'kubernetes',
};
